import React from "react";
import ModalFormProducto from "./ModalFormProducto";

const ModalProducto = ({ show, handleClose, producto }) => {
  return (
    <ModalFormProducto show={show} handleClose={handleClose} producto={producto} />
  );
};

export default ModalProducto;
